module.exports = __webpack_public_path__ + "static/media/zalopay.94da3299.png";